/* eslint-disable no-nested-ternary */
/* eslint-disable no-param-reassign */
import { launchChat } from '../sf-utils/chat-actions';

export const updatePPAGInlineButton = (buttonText: string, disabled: boolean, matchedStyle?: string) => {
  console.info('###UPDATE PPAG');

  const chatbuttons = document.querySelectorAll('#start-chat-button');

  chatbuttons.forEach((button) => {
    (button as HTMLAnchorElement)?.removeAttribute('href');
    if (!disabled) {
      (button as HTMLAnchorElement).onclick = () => {
        launchChat();
      };
    } else {
      (button as HTMLAnchorElement).onclick = () => {
        console.info('PPAG  button disabled');
      };
    }

    (button as HTMLAnchorElement).innerHTML = ` <img
    src="${
      disabled
        ? 'https://cms.cloudinary.vpsvc.com/image/upload/fl_sanitize,q_auto/help_center/chat-icon-disabled.svg'
        : matchedStyle === 'white'
        ? 'https://cms.cloudinary.vpsvc.com/image/upload/fl_sanitize,q_auto/help_center/chat-icon-black.svg'
        : 'https://cms.cloudinary.vpsvc.com/image/upload/fl_sanitize,q_auto/help_center/chat-icon-white.svg'
    }"
    alt="image"
    class="swan-icon swan-icon-mask swan-icon-size-standard swan-icon-skin-standard swan-icon-type-image caHelpIconBg"
    id="caButtonIcon"
  />${buttonText}`;

    if (matchedStyle === 'black' && !disabled) {
      (button as HTMLAnchorElement).style.backgroundColor = '#000000';
      (button as HTMLAnchorElement).style.borderColor = '#000000';
      (button as HTMLAnchorElement).style.color = '#ffffff';
    }
    if (matchedStyle === 'white' && !disabled) {
      (button as HTMLAnchorElement).style.backgroundColor = '#ffffff';
      (button as HTMLAnchorElement).style.borderColor = '#ffffff';
      (button as HTMLAnchorElement).style.color = '#000000';
    }
    if (disabled) {
      (button as HTMLAnchorElement).style.backgroundColor = '#dfdfdf';
      (button as HTMLAnchorElement).style.borderColor = '#dfdfdf';
      (button as HTMLAnchorElement).style.color = '#9e9e9e';
    }
  });
};
